import React from 'react';
import { Layout } from "antd";
import ComingSoon from '../layouts/comingSoon.layout';


const HomePage  : React.FC = () => {
  return (
     <Layout>
        <ComingSoon title="Home page ainda não concebida"/>
    </Layout>
  );
};

export default HomePage ;
